import React from "react";

function DeletModel(props) {
  const { handleConfirmDelete, handleCancelDelete } = props;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Confirm Delete</h2>
        <p className="text-sm text-gray-600 mb-6">Are you sure you want to delete?</p>
        <div className="flex justify-end gap-3">
          <button onClick={handleConfirmDelete} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
            Ok
          </button>
          <button
            onClick={handleCancelDelete}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeletModel;
